import coreStore from "./core-store";
import Axios from 'axios'

const remoteResource = 'reconciliation/api/v1/auto-matches';

const store = coreStore.createCoreStore('importFile', remoteResource);

store.actions.fetchResultForCashEventId = ({commit}, id) => {
    const searchQuery = {"parameters": {"cashEventId": {"operator": "eq", "type": "string", "value": `${id}`}}};
    return Axios.get(`${remoteResource}?searchQuery=${encodeURI(JSON.stringify(searchQuery))}`)
        .then(res => res.data)
}

export default store;
